import { object, string } from 'superstruct';
import { parsableInteger } from './parsableInteger';
export const IdObject = object({
  id: parsableInteger()
});
export const IdObjectWithName = object({
  id: parsableInteger(),
  name: string()
});